// Paper sizes offered by the print-size dropdown for picklist / manifest printing.
export const PRINT_PAGE_SIZES = {
  LABEL_4X6: 'label_4x6',
  A4: 'a4',
};

export const DEFAULT_PRINT_PAGE_SIZE = PRINT_PAGE_SIZES.LABEL_4X6;

export const PRINT_PAGE_SIZE_OPTIONS = [
  {
    value: PRINT_PAGE_SIZES.LABEL_4X6,
    label: '4×6" Label',
    description: 'Thermal label printer',
  },
  {
    value: PRINT_PAGE_SIZES.A4,
    label: 'A4',
    description: 'Office printer',
  },
];

// localStorage keys for the last size used, per document type
export const PRINT_PAGE_SIZE_STORAGE_KEYS = {
  PICKLIST: 'picklistPrintPageSize',
  MANIFEST: 'manifestPrintPageSize',
};

export const isValidPrintPageSize = value =>
  Object.values(PRINT_PAGE_SIZES).includes(value);
